import React from 'react';
import { Box, Typography, Button, Grid, CircularProgress, Alert } from '@mui/material';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import NewsCard from './NewsCard';
import { newsApi } from '../services/api';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const NewsDashboardWidget: React.FC = () => {
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery({
    queryKey: ['dashboard-news'],
    queryFn: () => newsApi.getNewsPosts({ limit: 5 }),
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error">
        Failed to load news. Please try again later.
      </Alert>
    );
  }

  if (!data || data.posts.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <NewspaperIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          No news posts available yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <NewspaperIcon color="primary" sx={{ fontSize: 28 }} />
          <Typography variant="h5" component="h2">
            Latest News
          </Typography>
        </Box>
        <Button
          variant="outlined"
          endIcon={<ArrowForwardIcon />}
          onClick={() => navigate('/news')}
        >
          View All
        </Button>
      </Box>

      {/* News Grid */}
      <Grid container spacing={3}>
        {data.posts.map((post) => (
          <Grid item xs={12} sm={6} md={4} key={post.id}>
            <NewsCard post={post} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default NewsDashboardWidget;
